import {
  TIPO_COMPROBANTE_FACTURA_CREDITO_FISCAL as ECF_FACTURA_CREDITO_FISCAL,
  TIPO_COMPROBANTE_FACTURA_CONSUMO as ECF_FACTURA_CONSUMO,
  TIPO_COMPROBANTE_COMPRAS as ECF_COMPRAS,
  TIPO_COMPROBANTE_REGIMEN_ESPECIAL as ECF_REGIMEN_ESPECIAL,
  TIPO_COMPROBANTE_GUBERNAMENTAL as ECF_GUBERNAMENTAL,
  TIPO_COMPROBANTE_EXPORTACIONES as ECF_EXPORTACIONES,
  TIPO_COMPROBANTE_PAGOS_EXTERIOR as ECF_PAGOS_EXTERIOR
} from "models/ECF/ECF";

// Estados
const ESTATUS_ACTIVO = "A";
const ESTATUS_ACTIVO_LABEL = "Activo";
const ESTATUS_INACTIVO = "I";
const ESTATUS_INACTIVO_LABEL = "Inactivo";

//Tipo Documento
export const TIPO_DOCUMENTO_CEDULA = "C";
export const TIPO_DOCUMENTO_CEDULA_LABEL = "Cedula";
export const TIPO_DOCUMENTO_RNC = "R";
export const TIPO_DOCUMENTO_RNC_LABEL = "RNC";
export const TIPO_DOCUMENTO_PASAPORTE = "P";
export const TIPO_DOCUMENTO_PASAPORTE_LABEL = "Pasaporte";

//Tipo Comprobante
const TIPO_COMPROBANTE_CREDITO_FISCAL = "F";
const TIPO_COMPROBANTE_CREDITO_FISCAL_LABEL = "Credito Fiscal";
const TIPO_COMPROBANTE_CONSUMO = "C";
const TIPO_COMPROBANTE_CONSUMO_LABEL = "Consumo";
const TIPO_COMPROBANTE_GUBERNAMENTAL = "G";
const TIPO_COMPROBANTE_GUBERNAMENTAL_LABEL = "Gubernamental";
const TIPO_COMPROBANTE_EXPORTACIONES = "E";
const TIPO_COMPROBANTE_EXPORTACIONES_LABEL = "Exportaciones";
const TIPO_COMPROBANTE_PAGOS_EXTERIOR = "P";
const TIPO_COMPROBANTE_PAGOS_EXTERIOR_LABEL = "Pagos Exterior";
const TIPO_COMPROBANTE_REGIMEN_ESPECIAL = "R";
const TIPO_COMPROBANTE_REGIMEN_ESPECIAL_LABEL = "Regimen Especial";
const TIPO_COMPROBANTE_COMPRAS = "S";
const TIPO_COMPROBANTE_COMPRAS_LABEL = "Compras";


export class Cliente {
  static get ESTATUS_LIST() {
    return [
      { value: ESTATUS_ACTIVO, label: ESTATUS_ACTIVO_LABEL },
      { value: ESTATUS_INACTIVO, label: ESTATUS_INACTIVO_LABEL }
    ];
  }

  static get TIPO_DOCUMENTO_LIST() {
    return [
      { value: TIPO_DOCUMENTO_CEDULA, label: TIPO_DOCUMENTO_CEDULA_LABEL },
      { value: TIPO_DOCUMENTO_RNC, label: TIPO_DOCUMENTO_RNC_LABEL },
      { value: TIPO_DOCUMENTO_PASAPORTE, label: TIPO_DOCUMENTO_PASAPORTE_LABEL }
    ];
  }
  static get TIPO_COMPROBANTE_LIST() {
    return [
      { value: TIPO_COMPROBANTE_CREDITO_FISCAL, label: TIPO_COMPROBANTE_CREDITO_FISCAL_LABEL },
      { value: TIPO_COMPROBANTE_CONSUMO, label: TIPO_COMPROBANTE_CONSUMO_LABEL },
      { value: TIPO_COMPROBANTE_GUBERNAMENTAL, label: TIPO_COMPROBANTE_GUBERNAMENTAL_LABEL },
      { value: TIPO_COMPROBANTE_EXPORTACIONES, label: TIPO_COMPROBANTE_EXPORTACIONES_LABEL },
      { value: TIPO_COMPROBANTE_PAGOS_EXTERIOR, label: TIPO_COMPROBANTE_PAGOS_EXTERIOR_LABEL },
      { value: TIPO_COMPROBANTE_REGIMEN_ESPECIAL, label: TIPO_COMPROBANTE_REGIMEN_ESPECIAL_LABEL },
      { value: TIPO_COMPROBANTE_COMPRAS, label: TIPO_COMPROBANTE_COMPRAS_LABEL },
    ];
  }
  static getTipoComprobante(comprobante) {
    switch (comprobante) {
      case TIPO_COMPROBANTE_CREDITO_FISCAL:
        return TIPO_COMPROBANTE_CREDITO_FISCAL_LABEL;
      case TIPO_COMPROBANTE_CONSUMO:
        return TIPO_COMPROBANTE_CONSUMO_LABEL;
      case TIPO_COMPROBANTE_GUBERNAMENTAL:
        return TIPO_COMPROBANTE_GUBERNAMENTAL_LABEL;
      case TIPO_COMPROBANTE_EXPORTACIONES:
        return TIPO_COMPROBANTE_EXPORTACIONES_LABEL;
      case TIPO_COMPROBANTE_PAGOS_EXTERIOR:
        return TIPO_COMPROBANTE_PAGOS_EXTERIOR_LABEL;
      case TIPO_COMPROBANTE_REGIMEN_ESPECIAL:
        return TIPO_COMPROBANTE_REGIMEN_ESPECIAL_LABEL;
      case TIPO_COMPROBANTE_COMPRAS:
        return TIPO_COMPROBANTE_COMPRAS_LABEL;
    }
  }

  static getTipoDocumento(documento) {
    switch (documento) {
      case TIPO_DOCUMENTO_CEDULA:
        return TIPO_DOCUMENTO_CEDULA_LABEL;
      case TIPO_DOCUMENTO_RNC:
        return TIPO_DOCUMENTO_RNC_LABEL;
      case TIPO_DOCUMENTO_PASAPORTE:
        return TIPO_DOCUMENTO_PASAPORTE_LABEL;
    }
  }

  static getEstatusTexto(estatus) {
    switch (estatus) {
      case ESTATUS_ACTIVO:
        return ESTATUS_ACTIVO_LABEL;
      case ESTATUS_INACTIVO:
        return ESTATUS_INACTIVO_LABEL;
    }
  }

  static get DEFAULT_ESTATUS_VALUE() {
    return ESTATUS_ACTIVO;
  }

  static getTipoComprobanteECF(clienteTipo) {
    switch (clienteTipo) {
      case TIPO_COMPROBANTE_CREDITO_FISCAL:
        return ECF_FACTURA_CREDITO_FISCAL;
      case TIPO_COMPROBANTE_CONSUMO:
        return ECF_FACTURA_CONSUMO;
      case TIPO_COMPROBANTE_GUBERNAMENTAL:
        return ECF_GUBERNAMENTAL;
      case TIPO_COMPROBANTE_EXPORTACIONES:
        return ECF_EXPORTACIONES;
      case TIPO_COMPROBANTE_PAGOS_EXTERIOR:
        return ECF_PAGOS_EXTERIOR;
      case TIPO_COMPROBANTE_REGIMEN_ESPECIAL:
        return ECF_REGIMEN_ESPECIAL;
      case TIPO_COMPROBANTE_COMPRAS:
        return ECF_COMPRAS;
    }
  }

  static get PROPIEDADES_EXPORTAR() {
    const propiedades = [
      { value: "IdSec", label: "ID" },
      { value: "RazonSocial", label: "Nombre" },
      { value: "Documento", label: "Documento" },
      { value: "Contacto", label: "Telefono" },
      { value: "Email", label: "Correo" },
      { value: "Direccion", label: "Direccion" },
      { value: "TipoDesc", label: "Tipo Comprobante" },
      { value: "TipoDocumentoDesc", label: "Tipo Documento" },
      { value: "CodigoInterno", label: "Codigo Interno" },
      { value: "EstatusDesc", label: "Estatus" },
      { value: "FechaCreacion", label: "Fecha Creacion" },
      { value: "CrearUsuario", label: "Usuario Creación" },
      { value: "ActualizarUsuario", label: "Usuario Actualización" },
    ];
    return propiedades.sort((a, b) => (a.label > b.label ? 1 : -1));
  }
}